import { useContext, useEffect, useRef } from 'react'
import { MIDIOutput } from '../types/WebMidi'
import { UserContext, UserContextType } from '../UserContext'
import { extractErrorMessage } from '../utils'

export default function useMidiPassthroughService() {
    const { state } = useContext(UserContext) as UserContextType

    const midiPassthroughOutputRef = useRef<MIDIOutput | null>(null)

    useEffect(() => {
        const midiInput = state.mediaSources.midiInputs.find((a) => a.id === state.mediaSelection.midiInput) || null

        const handler = (ev: any) => {
            const { data } = ev

            // filter out SysEx messages, ActiveSensing, and other undesired messages.
            // Note: Its effect is not completely understood.
            if ((data[0] & 0xf0) === 0xf0) {
                return
            }

            console.log('useMidiPassthroughService: midimessage event; data=' + JSON.stringify(data))
            // passthrough: send this to `midiPassthroughOutput`, if exists.
            if (midiPassthroughOutputRef.current) {
                try {
                    console.log('useMidiPassthroughService: midiPassthroughOutputRef is defined so sending.')
                    midiPassthroughOutputRef.current.send(data)
                } catch (e) {
                    console.error(`useMidiPassthroughService: send() error! message="${extractErrorMessage(e)}"`)
                }
            }
        }

        if (midiInput) {
            console.log('useMidiPassthroughService: adding event listener.')
            midiInput.addEventListener('midimessage', handler)
        }

        return () => {
            if (midiInput) {
                console.log('useMidiPassthroughService: removing event listener.')
                midiInput.removeEventListener('midimessage', handler)
            }
        }
    }, [state.mediaSelection.midiInput, state.mediaSources.midiInputs])

    useEffect(() => {
        const midiPassthroughOutput =
            state.mediaSources.midiOutputs.find((a) => a.id === state.mediaSelection.midiPassthroughOutput) || null
        midiPassthroughOutputRef.current = midiPassthroughOutput
    }, [state.mediaSelection.midiPassthroughOutput, state.mediaSources.midiOutputs])
}
